import { FunctionComponent } from "react"
import ResetPasswordForm from "../features/auth/components/reset-password-form"

const ResetPassword: FunctionComponent = () => {
  return (
    <div className="relative bg-base-white w-full h-[100dvh] flex flex-col pt-[170px] px-8 pb-12 box-border items-center justify-start">
      <ResetPasswordForm />
    </div>
  )
}

export default ResetPassword
